import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="bg-bone min-h-[70vh] flex items-center"
    >
      <div className="tr-container py-24 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-8">
          <div className="overline text-vermilion mb-6">404</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.98] tracking-tight">
            This page wandered off.
          </h1>
          <p className="mt-6 text-lg text-ink/70 max-w-xl">
            It happens. Head back to the homepage or explore our work.
          </p>
          <div className="mt-10 flex gap-4">
            <Link to="/" data-testid="notfound-home" className="btn-primary">
              Back home
            </Link>
            <Link to="/work" data-testid="notfound-work" className="btn-outline">
              See our work
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
